// @flow
import Themes from 'components/newsletter/Themes';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/newsletter/Themes';

export default connect(
  (state: StateType): StateProps => ({
    categoriesArticle: state.newsletterState.categoriesArticle,
  })
)(Themes);
